// extracted by mini-css-extract-plugin
export default {"payment":"px","title_row":"qx","border_bottom":"rx","promo_wrapper":"sx","payment_wrapper":"tx","label":"ux","card_row":"vx","cardcontain":"wx","card_input":"xx","card_error":"yx","card_label":"zx","lock":"Ax","same_address":"Bx","place_order_button":"Cx","buttonwrap":"Ex","hide_form":"Fx","paypal_buttons":"Gx","review_button":"Hx","alt_payment":"Ix"};
    if(module.hot) {
      // 1737143654493
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  